"use client";

import { useEffect } from "react";

const PARTNER_TEST_ACCOUNT_ID = "TEST-75R-R7R-6Z7Z";
const PARTNER_ACCOUNT_ID = "65R-R7R-6Z7Z";
const DEFAULT_ACCOUNT_ID = "R9K-97K-8Z6Z";
const CLEVERTAP_READY_EVENT = "clevertap:ready";

declare global {
  interface Window {
    __clevertapInitialized?: boolean;
    __clevertapInitializing?: boolean;
  }
}

const getCookie = (cookieName: string): string => {
  const key = `${cookieName}=`;
  const cookieList = document.cookie.split(";");

  for (const element of cookieList) {
    const cookie = element.trimStart();
    if (cookie.startsWith(key)) {
      return cookie.slice(key.length);
    }
  }

  return "";
};

export const getCleverTapAccountId = (locationHref: string): string => {
  if (locationHref.startsWith("https://b2bpartners.bajajfinserv.in")) {
    return PARTNER_TEST_ACCOUNT_ID;
  }

  if (locationHref.startsWith("https://partners.bajajfinserv.in")) {
    return PARTNER_ACCOUNT_ID;
  }

  return DEFAULT_ACCOUNT_ID;
};

const getAuthType = (): "Identified" | "UnIdentified" => {
  const authTypeCookie = getCookie("authType");
  return authTypeCookie === "I" || authTypeCookie === "A"
    ? "Identified"
    : "UnIdentified";
};

const getPwaMode = (): 0 | 1 => {
  return window.matchMedia("(display-mode: standalone)").matches ? 1 : 0;
};

const Clevertap = () => {
  useEffect(() => {
    if (window.location.href.includes("/app-v")) {
      return;
    }

    if (window.__clevertapInitialized) {
      return;
    }
    if (window.__clevertapInitializing) {
      return;
    }
    window.__clevertapInitializing = true;

    const queryParam = new URLSearchParams(window.location.search);
    const webViewMode = getCookie("webViewMode");
    const isWebView = queryParam.get("src") === "3in1" || webViewMode === "on";

    if (isWebView) {
      document.cookie =
        "tokenSrc=3in1; path=/; domain=.bajajfinserv.in; secure; samesite=strict";
    }

    const accountId = getCleverTapAccountId(window.location.href);
    void import("clevertap-web-sdk")
      .then(({ default: clevertap }) => {
        clevertap.privacy.push({ optOut: false }, { useIP: true });
        clevertap.init(accountId, "in1");
        window.__clevertapInitialized = true;
        window.dispatchEvent(new Event(CLEVERTAP_READY_EVENT));

        if (!isWebView) {
          clevertap.event.push("page_view", {
            page_url: window.location.href,
            authType: getAuthType(),
            isPWA: getPwaMode(),
          });
        }
      })
      .finally(() => {
        window.__clevertapInitializing = false;
      });
  }, []);

  return null;
};

export default Clevertap;